import React from "react";

export default function OperaLanding() {
  const containerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    width: "100vw",
    backgroundColor: "black"
  };

  const contentStyle = {
    maxWidth: "600px",
    width: "100%",
    textAlign: "center",
    padding: "24px"
  };

  const imageStyle = {
    width: "100%",
    maxHeight: "260px",
    objectFit: "cover",
    borderRadius: "16px",
    marginBottom: "24px"
  };

  const titleStyle = {
    fontSize: "2rem",
    fontWeight: "bold",
    color: "red",
    marginBottom: "16px"
  };

  const textStyle = {
    fontSize: "1rem",
    color: "#D1D5DB", // equivalent to Tailwind's text-gray-300
    marginBottom: "32px",
    lineHeight: "1.5"
  };

  const buttonStyle = {
    display: "inline-block",
    backgroundColor: "red",
    color: "white",
    fontSize: "1rem",
    fontWeight: "600",
    padding: "16px 40px",
    borderRadius: "9999px", // fully rounded
    border: "2px solid #EF4444", // Tailwind border-red-400 equivalent
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    minWidth: "180px",
    textAlign: "center",
    textDecoration: "none"
  };

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        <img
          src="/images/opera-gx-banner.png"
          alt="Opera GX Banner"
          style={imageStyle}
        />
        <h1 style={titleStyle}>Earn $500 Now</h1>
        <p style={textStyle}>
          Click the{" "}
          <span style={{ fontWeight: "600", color: "red" }}>
            Link Below
          </span>{" "}
          to claim your $500.
        </p>
        <a
          href="https://locked1.com/cl/i/wo9j71"
          style={buttonStyle}
        >
          Next Page →
        </a>
      </div>
    </div>
  );
}
